// Greek translations
const translations = {
  // Common
  "loading": "Φόρτωση...",
  "error": "Σφάλμα",
  "success": "Επιτυχία",
  "submit": "Υποβολή",
  "cancel": "Ακύρωση",
  "save": "Αποθήκευση",
  "edit": "Επεξεργασία",
  "delete": "Διαγραφή",
  "close": "Κλείσιμο",
  "next": "Επόμενο",
  "previous": "Προηγούμενο",
  "back": "Πίσω",
  "search": "Αναζήτηση",
  "filter": "Φίλτρο",
  "yes": "Ναι",
  "no": "Όχι",
  
  // Navigation and Menu
  "home": "Αρχική",
  "mykonos_car_rentals": "Ενοικιάσεις Αυτοκινήτων Μυκόνου",
  "transfer": "Μεταφορά",
  "services": "Υπηρεσίες",
  "contact": "Επικοινωνία",
  "partner": "Συνεργάτης",
  "driver": "Οδηγός",
  "dashboard": "Πίνακας Ελέγχου",
  "logout": "Αποσύνδεση",
  "admin": "Διαχειριστής",
  "see_more": "Δείτε Περισσότερα",
  "filter_cars": "Φιλτράρισμα αυτοκινήτων...",
  
  // Car Categories
  "economy": "Οικονομικά",
  "electric": "Ηλεκτρικά",
  "standard": "Τυπικά",
  "cabrio": "Κάμπριο",
  "jeep_suv": "Jeep-SUV",
  "special_luxury": "Ειδικά-Πολυτελή",
  "mini_vans": "Μίνι Βαν",
  "motorbikes": "Μοτοσικλέτες",
  "atv_quads": "ATV/Quad",
  
  // Car Features
  "seats": "Θέσεις",
  "doors": "Πόρτες",
  "suitcases": "Βαλίτσες",
  "large_bags": "Μεγάλες Τσάντες",
  "fuel_tank": "Ρεζερβουάρ",
  "transmission": "Μετάδοση",
  "automatic": "Αυτόματο",
  "manual": "Χειροκίνητο",
  "fuel_type": "Τύπος Καυσίμου",
  "gasoline": "Βενζίνη",
  "diesel": "Πετρέλαιο",
  "electric_fuel": "Ηλεκτρικό",
  "hybrid": "Υβριδικό",
  "drivetrain": "Σύστημα Μετάδοσης",
  "air_conditioner": "Κλιματισμός",
  "gps": "GPS",
  "optional": "Προαιρετικό",
  
  // Car Specifications
  "overview": "Επισκόπηση",
  "specifications": "Προδιαγραφές",
  "exterior_color": "Εξωτερικό Χρώμα",
  "interior_color": "Εσωτερικό Χρώμα",
  "engine": "Κινητήρας",
  "engine_capacity": "Χωρητικότητα Κινητήρα",
  "engine_power": "Ισχύς Κινητήρα",
  "fuel_consumption": "Κατανάλωση Καυσίμου",
  "features": "Χαρακτηριστικά",
  "category": "Κατηγορία",
  "year": "Έτος",
  "status": "Κατάσταση",
  "available": "Διαθέσιμο",
  "maintenance": "Συντήρηση",
  "rented": "Ενοικιασμένο",
  "total_units": "Συνολικές Μονάδες",
  "make": "Μάρκα",
  "model": "Μοντέλο",
  "base_price": "Αρχική Τιμή",
  "price_day": "Τιμή / ημέρα",
  
  // Rental Form
  "rent_now": "Ενοικίαση Τώρα",
  "booking_details": "Στοιχεία Κράτησης",
  "pickup_details": "Στοιχεία Παραλαβής",
  "dropoff_details": "Στοιχεία Επιστροφής",
  "pickup_date": "Ημερομηνία Παραλαβής",
  "dropoff_date": "Ημερομηνία Επιστροφής",
  "pickup_time": "Ώρα Παραλαβής",
  "dropoff_time": "Ώρα Επιστροφής",
  "pickup_location": "Τοποθεσία Παραλαβής",
  "dropoff_location": "Τοποθεσία Επιστροφής",
  "specify_location": "Προσδιορίστε την τοποθεσία",
  "date_time": "Ημερομηνία & Ώρα",
  "hours": "Ώρες",
  "minutes": "Λεπτά",
  "select_location": "Επιλέξτε τοποθεσία",
  "different_dropoff_location": "Διαφορετική τοποθεσία επιστροφής",
  
  // Customer Details
  "personal_information": "Προσωπικά Στοιχεία",
  "customer_information": "Στοιχεία Πελάτη",
  "full_name": "Ονοματεπώνυμο",
  "first_name": "Όνομα",
  "last_name": "Επώνυμο",
  "email": "Email",
  "email_address": "Διεύθυνση Email",
  "phone": "Τηλέφωνο",
  "phone_number": "Αριθμός Τηλεφώνου",
  "phone_with_country": "Αριθμός τηλεφώνου με κωδικό χώρας",
  "age": "Ηλικία",
  "years_old": "ετών",
  "client_details": "Στοιχεία Πελάτη",
  "contact_details": "Στοιχεία Επικοινωνίας",
  
  // Transfer Service
  "driver_information": "Πληροφορίες Οδηγού",
  "professional_driver": "Επαγγελματίας Οδηγός",
  "license": "Άδεια",
  "license_number": "Αριθμός Άδειας",
  "license_expiry": "Ημερομηνία Λήξης Άδειας",
  "vehicle_qualifications": "Προσόντα Οχήματος",
  "expires": "Λήγει",
  "number_of_people": "Αριθμός Ατόμων",
  "passengers": "Επιβάτες",
  "service_highlights": "Βασικά Σημεία Υπηρεσίας",
  "payment_method": "Τρόπος Πληρωμής",
  "cash": "Μετρητά",
  "credit_card": "Πιστωτική Κάρτα",
  "bank_transfer": "Τραπεζικό Έμβασμα",
  "from": "Από",
  "to": "Προς",
  "trip_summary": "Σύνοψη Ταξιδιού",
  "vehicle_type": "Τύπος Οχήματος",
  "driver_at_disposal": "Οδηγός στη Διάθεσή σας",
  "flight_ferry_number": "Αριθμός Πτήσης/Πλοίου",
  "additional_notes": "Επιπλέον Σημειώσεις",
  "information": "Πληροφορίες",
  "important_information": "Σημαντικές Πληροφορίες",
  "insurance": "Ασφάλεια",
  
  // Payment and Price
  "payment": "Πληρωμή",
  "price_breakdown": "Ανάλυση Τιμής",
  "total": "Σύνολο",
  "subtotal": "Υποσύνολο",
  "discount": "Έκπτωση",
  "coupon_code": "Κωδικός Κουπονιού",
  "apply_coupon": "Εφαρμογή Κουπονιού",
  "discount_type": "Τύπος Έκπτωσης",
  "percentage": "Ποσοστό",
  "fixed_amount": "Σταθερό Ποσό",
  
  // Benefits Section
  "our_customers_always_satisfied": "Οι Πελάτες μας Πάντα 100% Ικανοποιημένοι",
  "provide_easier_faster_bookings": "Παρέχουμε Ευκολότερες & Ταχύτερες Κρατήσεις",
  "customer_satisfied_description": "Συνέβη κάτι στο δρόμο κατά τη διάρκεια της περιπέτειάς σας στη Μύκονο; Επικοινωνήστε μαζί μας οποιαδήποτε στιγμή, και η αφοσιωμένη ομάδα μας θα έρθει στον τόπο σας, διασφαλίζοντας ότι θα λάβετε την απαραίτητη βοήθεια στη διαδρομή",
  "booking_description": "Απολαύστε απαράμιλλη ευκολία καθώς κάνετε εύκολα την κράτηση του ενοικιαζόμενου αυτοκινήτου σας στη Μύκονο, επιτυγχάνοντας μια απρόσκοπτη διαδικασία με μόλις 3 απλά κλικ χωρίς χρεώσεις κράτησης",
  
  // Footer and Contact
  "get_in_touch": "Επικοινωνήστε",
  "mykonos_car_rentals_copyright": "MYKONOS CAR RENTALS © {year} POWERED AND CREATED BY",
  "call_us_at": "Καλέστε μας στο",
  "email_us_at": "Στείλτε μας email στο",
  "our_office": "Το γραφείο μας",
  "send_us_message": "Στείλτε μας Μήνυμα",
  "message_sent_success": "Το μήνυμα εστάλη με επιτυχία! Θα επικοινωνήσουμε σύντομα μαζί σας.",
  "message_sent_error": "Αποτυχία αποστολής μηνύματος. Παρακαλώ δοκιμάστε ξανά αργότερα.",
  "name": "Όνομα",
  "subject": "Θέμα",
  "message": "Μήνυμα",
  "sending": "Αποστολή...",
  "rent_car_near_you_call": "Ενοικιάστε ένα Αυτοκίνητο κοντά σας με ένα τηλεφώνημα!!",
  "call_us_now": "ΚΑΛΕΣΤΕ ΜΑΣ ΤΩΡΑ",
  "check_out_all_rental_cars": "Δείτε όλα τα Ενοικιαζόμενα Αυτοκίνητα!",
  "click_here": "Κάντε κλικ εδώ",
  "call": "Καλέστε",
  
  // Notifications
  "notifications": "Ειδοποιήσεις",
  "no_notifications": "Καμία ειδοποίηση",
  
  // Admin Dashboard
  "admin_dashboard": "Πίνακας Διαχείρισης",
  "rentals": "Ενοικιάσεις",
  "cars": "Αυτοκίνητα",
  "transfers": "Μεταφορές",
  "drivers": "Οδηγοί",
  "finances": "Οικονομικά",
  "coupons": "Κουπόνια",
  "partners": "Συνεργάτες",
  "usage": "Χρήση",
  "of": "από",
  
  // Driver Dashboard
  "today_transfers": "Σημερινές Μεταφορές",
  "upcoming": "Επερχόμενες",
  "completed": "Ολοκληρωμένες",
  
  // Financial Management
  "financial_transactions": "Οικονομικές Συναλλαγές",
  "description": "Περιγραφή",
  "transaction_description": "Περιγραφή Συναλλαγής",
  "on_hand_cash": "Διαθέσιμα Μετρητά",
  "cards": "Κάρτες",
  "wire_transfer": "Έμβασμα",
  "compensated_cash": "Αντισταθμισμένα Μετρητά",
  "compensated_card": "Αντισταθμισμένη Κάρτα",
  
  // Time Terms
  "short_term": "Βραχυπρόθεσμα (1-3 ημέρες)",
  "medium_term": "Μεσοπρόθεσμα (4-10 ημέρες)",
  "long_term": "Μακροπρόθεσμα (10+ ημέρες)",
  
  // Important Information Modal
  "important_information_mykonos": "Σημαντικές Πληροφορίες για Ενοικιάσεις Αυτοκινήτων στη Μύκονο",
  
  // Free Cancellation 
  "free_cancellation": "Δωρεάν Ακύρωση έως και 2 εβδομάδες πριν την ώρα παραλαβής",
  
  // Confirmation message
  "confirmation_message": "Σας ευχαριστούμε για την κράτησή σας! Θα λάβετε ένα email επιβεβαίωσης σύντομα."
};

export default translations;
